import { ReactNode } from "react";

export const DialogActions = (props: { children: ReactNode }) => {
  return <div className="mt-auto">{props.children}</div>;
};
